import { Box, addWithConfig } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

import ActionButton from 'components/action-button';
import BellIcon from 'components/icons/bell-icon';
import { primitive, spacing } from 'styles/constants';

export const StyledBellIcon = BellIcon.withConfig(() => ({
  size: '$5',
  position: 'relative',
}));

export const UnreadNotificationBadge = Box.withConfig(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'absolute',
  left: '-16px',
  top: '-18px',
  minWidth: '$4',
  height: '$4',
  background: primitive.$fieryRed,
  borderRadius: 'full',
}));

export const BadgeText = withTypography({
  color: 'white',
  fontSize: '2xs',
  px: '$1',
  lineHeight: 10,
  style: { height: spacing.$2_5 },
});

export const StyledNotificationButton = addWithConfig(ActionButton).withConfig({
  paddingLeft: '$4',
  paddingRight: '$0',
  _web: {
    paddingLeft: '$0',
    paddingRight: '$0',
  },
});
